import { render, staticRenderFns } from "./Vertically.vue?vue&type=template&id=43635e12"
import script from "./Vertically.vue?vue&type=script&lang=js"
export * from "./Vertically.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports